const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validate(values) {
  const errors = {};

  const emailKey = `email-waitlist`;
  if (!values[emailKey]) {
    errors.email = "Email address is required";
  } else if (!emailValidator.test(values[emailKey])) {
    errors.email = "Email address is invalid";
  }

  return errors;
}
